import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { JwtCredentials } from '@tickethead/sdk';
import BInputField from '@/components/general/BInputField.vue';
import BButton from '@/components/general/BButton.vue';
import { parseJwt, errorMessage } from '~/utils/utils';
import { toCompleteRegistrationEvent } from '~/utils/facebook';
import { useUserStore } from '~/store/user';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'BRegister',
  emits: ['gotoLogin'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var sdk = useSdk();
    var userStore = useUserStore();
    var appStore = useAppStore();
    var notifier = useNotifier();
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var config = useRuntimeConfig();
    var _useMetaPixel = useMetaPixel(),
      trackPlatformMetaEvent = _useMetaPixel.trackPlatformMetaEvent;
    var username = ref('');
    var email = ref('');
    var password = ref('');
    var firstName = ref('');
    var lastName = ref('');
    var terms = ref(false);
    var usernameHasError = ref(false);
    var emailHasError = ref(false);
    var passwordHasError = ref(false);
    var registrationStartTracked = ref(false);
    var invalidFields = computed(function () {
      return usernameHasError.value || emailHasError.value || passwordHasError.value || username.value.length <= 0 || email.value.length <= 0 || password.value.length <= 0;
    });
    var isWhitelabelLite = computed(function () {
      return config.whitelabel.enabled;
    });
    var existingAccountMessage = computed(function () {
      return isWhitelabelLite.value ? t('main.existingAccount.whitelabel') : t('main.existingAccount');
    });
    var existingAccountLoginText = computed(function () {
      return isWhitelabelLite.value ? t('main.loginTitle.whitelabel') : t('main.loginTitle');
    });
    function gotoLogin() {
      emit('gotoLogin');
    }
    function register() {
      return _register.apply(this, arguments);
    }
    function _register() {
      _register = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var userPass, register, registerRes, authRes, token, refreshToken, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              userPass = {
                password: password.value,
                username: username.value
              };
              register = _objectSpread(_objectSpread({}, userPass), {}, {
                email: email.value,
                firstName: firstName.value,
                lastName: lastName.value
              }); // Track sign-ups through our whitelabels
              if (config.whitelabel.enabled) {
                register.referral_source = config.whitelabel.organizer;
              }
              _context.prev = 1;
              _context.next = 2;
              return sdk.account.createUser(register);
            case 2:
              registerRes = _context.sent;
              trackRegistrationComplete(registerRes);
              _context.next = 3;
              return sdk.auth.login(userPass);
            case 3:
              authRes = _context.sent;
              token = authRes === null || authRes === void 0 ? void 0 : authRes.token;
              refreshToken = authRes === null || authRes === void 0 ? void 0 : authRes.refreshToken; // Set SDK auth
              _context.next = 4;
              return sdk.authorize(new JwtCredentials({
                token: token,
                refreshToken: refreshToken
              }));
            case 4:
              _context.next = 5;
              return fetchUserInfo(token);
            case 5:
              appStore.setAuthDialog(false);
              document.body.style = '';
              _context.next = 7;
              break;
            case 6:
              _context.prev = 6;
              _t = _context["catch"](1);
              notifier.showMessage({
                content: errorMessage(_t, t('errors.genericRequest')),
                type: 'error'
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 6]]);
      }));
      return _register.apply(this, arguments);
    }
    function fetchUserInfo(_x) {
      return _fetchUserInfo.apply(this, arguments);
    }
    function _fetchUserInfo() {
      _fetchUserInfo = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(token) {
        var tokenInfo, user;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              tokenInfo = parseJwt(token);
              _context2.next = 1;
              return sdk.account.getUser({
                id: tokenInfo.id
              });
            case 1:
              user = _context2.sent;
              userStore.setUser(_objectSpread(_objectSpread({}, tokenInfo), user));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _fetchUserInfo.apply(this, arguments);
    }
    function trackRegistrationStart() {
      if (registrationStartTracked.value) {
        return;
      }
      registrationStartTracked.value = true;

      // Track registration start with Sportradar
      if (window.srtmCommands) {
        window.srtmCommands.push({
          event: 'track.user.registration',
          payload: {
            action: 'start'
          }
        });
      }
    }
    function trackRegistrationComplete(registerRes) {
      trackPlatformMetaEvent('CompleteRegistration', toCompleteRegistrationEvent(registerRes));
      // Sportradar
      if (window.srtmCommands) {
        window.srtmCommands.push({
          event: 'track.user.registration',
          payload: {
            action: 'complete',
            userId: registerRes.enrollmentId
          }
        });
      }
    }
    return {
      __sfc: true,
      emit: emit,
      sdk: sdk,
      userStore: userStore,
      appStore: appStore,
      notifier: notifier,
      t: t,
      config: config,
      trackPlatformMetaEvent: trackPlatformMetaEvent,
      username: username,
      email: email,
      password: password,
      firstName: firstName,
      lastName: lastName,
      terms: terms,
      usernameHasError: usernameHasError,
      emailHasError: emailHasError,
      passwordHasError: passwordHasError,
      registrationStartTracked: registrationStartTracked,
      invalidFields: invalidFields,
      isWhitelabelLite: isWhitelabelLite,
      existingAccountMessage: existingAccountMessage,
      existingAccountLoginText: existingAccountLoginText,
      gotoLogin: gotoLogin,
      register: register,
      fetchUserInfo: fetchUserInfo,
      trackRegistrationStart: trackRegistrationStart,
      trackRegistrationComplete: trackRegistrationComplete,
      BInputField: BInputField,
      BButton: BButton
    };
  }
});